module.exports = __webpack_public_path__ + "img/93.6.CODm.102bb334.png";